export class SaasSharePointSiteProperties {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "webUrl",
            "baseName": "webUrl",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SaasSharePointSiteProperties.attributeTypeMap;
    }
    constructor() {
    }
}
